import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ADMIN_PATHS = [
    '/admin-panel',
    '/add-vehicle',
    '/vehicles',
    '/view-user',
    '/create-account',
    '/view-sales',
    '/add-new-sale',
    '/documents-shipping',
    '/volet',
    '/create-volet',
    '/view-payments',
    '/create-allocate',
    '/accounts',
    '/portfolio',
    '/edit-vehicle',
    '/auction',
    '/create-group',
    '/view-groups',
    '/view-bids',
    '/view-leads',
    '/view-client',
    '/view-stock',
    '/view-sale-order',
    '/view-invoice',
    '/view-chat-admin',
    '/announcements',
    '/announcements/new',
];

const TAWK_SRC = 'https://embed.tawk.to/604705c51c1c2a130d666e88/1f0amt3t3';

const TawkToManager = () => {
    const location = useLocation();

    useEffect(() => {
        const isAdminRoute = ADMIN_PATHS.some(path =>
            location.pathname.startsWith(path)
        );

        if (isAdminRoute) {
            // ---- HIDE / UNLOAD Tawk.to on admin pages ----
            // Tawk exposes `hideWidget` to hide without destroying it.
            // Also hide the iframe container directly as a belt-and-suspenders.
            if (window.Tawk_API && typeof window.Tawk_API.hideWidget === 'function') {
                window.Tawk_API.hideWidget();
            }
            const tawkContainer = document.getElementById('tawkchat-container');
            if (tawkContainer) tawkContainer.style.display = 'none';

            // Also hide the launcher iframe specifically
            const launcherFrame = document.querySelector('iframe[title="chat widget"]');
            if (launcherFrame && launcherFrame.parentElement) {
                launcherFrame.parentElement.style.display = 'none';
            }
        } else {
            // ---- SHOW / LOAD Tawk.to on public pages ----
            if (!window.Tawk_API) {
                // First time on a public page — inject the script
                window.Tawk_API = window.Tawk_API || {};
                window.Tawk_LoadStart = new Date();
                const s1 = document.createElement('script');
                s1.async = true;
                s1.src = TAWK_SRC;
                s1.charset = 'UTF-8';
                s1.setAttribute('crossorigin', '*');
                document.head.appendChild(s1);
            } else {
                // Widget already loaded — just show it
                if (typeof window.Tawk_API.showWidget === 'function') {
                    window.Tawk_API.showWidget();
                }
                const tawkContainer = document.getElementById('tawkchat-container');
                if (tawkContainer) tawkContainer.style.display = '';
                const launcherFrame = document.querySelector('iframe[title="chat widget"]');
                if (launcherFrame && launcherFrame.parentElement) {
                    launcherFrame.parentElement.style.display = '';
                }
            }
        }
    }, [location.pathname]);

    return null;   // Renders nothing — pure side-effect component
};

export default TawkToManager;